import { role } from '@/apis';

export default {
  namespaced: true,
  state: {
    roleList: [],
    roleDetail: null,
    roleMap: {},
    funcList: [],
    slotsIds: [],
  },
  mutations: {
    fetchListStart(state) {
      state.roleList = [];
    },
    fetchListSuccess(state, data = []) {
      state.roleList = data;
    },
    fetchDetailStart(state) {
      state.roleDetail = null;
    },
    fetchDetailSuccess(state, data) {
      state.roleDetail = data;
    },
    fetchListByProductStart(state, productId) {
      state.roleMap = {
        ...state.roleMap,
        [productId]: [],
      };
    },
    fetchListByProductSuccess(state, {
      productId,
      data = [],
    }) {
      state.roleMap[productId] = data;
    },
    fetchFuncListStart(state) {
      state.funcList = [];
    },
    fetchFuncListSuccess(state, data = []) {
      state.funcList = data.map(func => Object.freeze(func));
    },
    updateSlotsIds(state, data = []) {
      state.slotsIds = data;
    },
  },
  actions: {
    async fetchList({
      commit,
    }, payload) {
      commit('fetchListStart');
      const list = await role.fetchPage(payload);
      commit('fetchListSuccess', list);
    },
    async fetchDetail({
      commit,
    }, payload) {
      commit('fetchDetailStart');
      const data = await role.fetchDetail(payload);
      commit('fetchDetailSuccess', data);
    },
    async fetchListByProduct({
      commit,
    }, payload) {
      const { productId } = payload;
      commit('fetchListByProductStart', productId);
      const data = await role.fetchList(payload);
      commit({
        type: 'fetchListByProductSuccess',
        productId,
        data,
      });
    },
    async fetchFuncList({
      commit,
    }, payload) {
      commit('fetchFuncListStart');
      const data = await role.fetchFuncList(payload);
      const btnList = data.filter(i => i.functionType === 'BUTTON');
      const slotsIds = data.filter(i => btnList.find(subItem => subItem.parentId === i.id)).map(i => i.id);
      commit('updateSlotsIds', slotsIds);
      commit('fetchFuncListSuccess', data);
    },
    async add(context, payload) {
      await role.add(payload);
    },
    async edit(context, payload) {
      await role.edit(payload);
    },
    async updateStatus(context, payload) {
      await role.updateStatus(payload);
    },
    async del(context, payload) {
      await role.del(payload);
    },
    async delCheck(context, payload) {
      const data = await role.del(payload);
      return data;
    },
  },
};
